
export const planNames = {
  month: "Monthly Plan",
  year: "Yearly Plan",
  lifetime: "Lifetime Plan",
  free_lifetime: "Free Lifetime Plan",
  team_plan: "Team Member Plan"
};


export const teamPlanNames = {
  month: "Monthly Team Plan",
  year: "Yearly Team Plan"
};
